import { memo } from "react";

import { Flex } from "@similarweb/ui-components/foundations";

import type { SignalFilters, SignalType } from "app/pages/sales-intelligence/domain/signals/types/signal";
import { FilterContentContainer } from "app/pages/sales-intelligence/modules/advanced-search-filtering/components/styles";
import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import SignalsManagementButton from "app/pages/sales-intelligence/sub-modules/signals/components/buttons/SignalsManagementButton/SignalsManagementButton";
import type UISignal from "app/pages/sales-intelligence/sub-modules/signals/models/view/UISignal";
import signalsI18nKeys from "app/pages/sales-intelligence/sub-modules/signals/utils/i18n";

import type SignalsFilter from "../../../models/SignalsFilter/SignalsFilter";

import SignalSelectGroup from "./SignalSelectGroup/SignalSelectGroup";

type Props = IFilterViewBaseProps<SignalsFilter> & {
    onCreateSignal: (signalType: SignalType) => void;
};

const SignalsView = ({ filter, value, onFilterUpdate, onCreateSignal }: Props) => {
    const selectedUISignals = filter.getSelectedUISignals(value);

    const handleSignalSelect = (uiSignal: UISignal<SignalFilters>): void => {
        onFilterUpdate(filter.toggleSelectedSignal(uiSignal, value));
    };

    return (
        <FilterContentContainer>
            <SignalSelectGroup
                signalType={filter.signalType}
                selectedUISignals={selectedUISignals}
                signals={filter.availableUISignals}
                onSignalSelect={handleSignalSelect}
            />

            <Flex justifyContent="center">
                <SignalsManagementButton
                    isSignalsListEmpty
                    emptyListBtnText={signalsI18nKeys.addSignal.shortCta}
                    onClick={() => onCreateSignal(filter.signalType)}
                />
            </Flex>
        </FilterContentContainer>
    );
};

export default memo(SignalsView);
